export default __webpack_public_path__ + "static/media/atm.026cfe40.svg";